"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Cell", {
  enumerable: true,
  get: function () {
    return _Cell.default;
  }
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function () {
    return _Row.default;
  }
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _Cell = _interopRequireDefault(require("./Cell"));
var _Row = _interopRequireDefault(require("./Row"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Table(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TableWrapper, {
    children: props.children
  });
}
Table.Cell = _Cell.default;
Table.Row = _Row.default;
var _default = exports.default = Table;